import React from "react";
import { BadgeDollarSign, CalendarClock, CheckCircle2 } from "lucide-react";
import DenefitsButton from "./DenefitsButton";

const perks = [
  { icon: BadgeDollarSign, text: "No credit-based denials — everyone qualifies" },
  { icon: CalendarClock, text: "Flexible monthly payment plans that fit your budget" },
  { icon: CheckCircle2, text: "Instant approval decision in under a minute" },
];

export default function Financing() {
  return (
    <section id="financing" className="bg-navy py-16 sm:py-20 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-10 items-center relative">
        <div>
          <div className="inline-flex items-center gap-2 bg-navy-light text-gold-light px-4 py-1.5 rounded-full text-sm font-medium mb-5">
            <BadgeDollarSign className="h-4 w-4" /> Financing Available
          </div>
          <h2 className="font-serif text-white text-3xl sm:text-4xl font-bold leading-tight">
            Flexible Payment Plans <span className="text-gold">Through Denefits</span>
          </h2>
          <p className="mt-4 text-gray-300 text-base md:text-lg leading-relaxed max-w-xl">
            Don't let upfront costs stand between you and your financial freedom.
            Get pre-approved for a payment plan in seconds — no hard credit check required.
          </p>
        </div>
        <div className="bg-navy-light/60 border border-navy-light rounded-xl p-6 sm:p-8">
          <ul className="space-y-4">
            {perks.map((p, i) => (
              <li key={i} className="flex items-start gap-3 text-gray-200">
                <p.icon className="h-5 w-5 text-gold mt-0.5 shrink-0" />
                <span>{p.text}</span>
              </li>
            ))}
          </ul>
          <div className="mt-7">
            <DenefitsButton testId="denefits-preapproval-btn-section" className="w-full sm:w-auto" />
          </div>
        </div>
      </div>
    </section>
  );
}
